import React, { Component } from 'react';


import NegativeComponent from './../components/ChartNegativeDashboard/NegativeComponent';
import './../../selections/timeSelection/components/timeSelect/cliente.css';


//Actualizacion develop
class AreaDB extends Component {        
        
    render() { 
        const {data, name, title} = this.props;
       return (
            <NegativeComponent 
                name={name}
                title={title}
                data={data}
                openDialog={this.props.openDialog}
                onClickGraphic={this.props.onClickGraphic}
                seeMore={this.props.seeMore}
            />
        );
    }
}

export default AreaDB;